import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { Application } from '@models';
import { NotificationService, ApplicationService } from '@services';
import { catchError, of } from 'rxjs';

export const applicationResolver: ResolveFn<Application | null> = (
  route: ActivatedRouteSnapshot,
) => {
  const service = inject(ApplicationService);
  const notificationService = inject(NotificationService);
  const router = inject(Router);

  const id = route.paramMap.get('id');
  if (!id) {
    return of(null);
  }

  return service.read(id).pipe(
    catchError((err) => {
      console.error(err);

      switch (err?.status) {
        case 401:
          break;
        default:
          router.navigate(['/404'], {
            skipLocationChange: true,
          }).finally(() => {
            notificationService.error('Failed to load the user application.');
          });
          break;
      }

      return of(null);
    }),
  );
};
